import Heading from "components/atoms/Heading";
import Image from "components/atoms/Image";
import Link from "components/atoms/Link";
import Text from "components/atoms/Text";
import React from "react";
import { joinClassnames, mapMultiClassnames } from "utils/map-modifier";
import "./index.scss";

interface ArticleProps {
  imgSrc: string;
  category: string;
  title: string;
  description: string;
  slug: string;
  className?: string;
  useHeadingh1?: React.ReactNode;
  modifiers?: ("small" | "row" | "smallRow")[];
}

const Article: React.FC<ArticleProps> = ({
  imgSrc,
  category,
  title,
  description,
  slug,
  modifiers,
  className,
  useHeadingh1,
}) => (
  <div
    className={joinClassnames(
      mapMultiClassnames("m-article", modifiers),
      className,
    )}
  >
    <Link href={`/kinh-nghiem-hay/${encodeURIComponent(slug)}`}>
      <div className={"m-article_image"}>
        <Image src={imgSrc} alt={title} />
      </div>
    </Link>

    <div className={"m-article_content"}>
      <div className={"m-article_content_category"}>
        <Text modifiers={["primary"]}>{category}</Text>
      </div>
      <Link href={`/kinh-nghiem-hay/${encodeURIComponent(slug)}`}>
        <div className={"m-article_content_title"}>
          {useHeadingh1 || <Heading>{title}</Heading>}
        </div>
      </Link>
      <div className={"m-article_content_description"}>
        <Text modifiers={["gray"]}>{description}</Text>
      </div>
    </div>
  </div>
);

Article.defaultProps = {};

export default Article;
